import React from "react";
import "./Item.css";
import ButtonMflUser from "shared/components/buttons/ButtonMflUser.js";
import ButtonMflAssistantUser from "shared/components/buttons/ButtonMflAssistantUser.js";

interface ItemRowWarningProps {
  c: object;
}

const ItemRowWarning: React.FC<ItemRowWarningProps> = ({ c }) => {
  return (
    <div className="Item ItemRowWarning cursor-default text-warning">
      <div className="d-flex flex-column flex-md-row flex-fill pb-1 pb-md-0">
        <div className="d-flex">
          <i className="bi bi-exclamation-triangle-fill me-1" />
          {c}
        </div>
      </div>
    </div>
  );
};

export default ItemRowWarning;
